var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "change-password-form" },
    [
      _c(
        "required-field",
        {
          attrs: {
            error: _vm.$v.password.$error,
            required: _vm.$v.password.required,
            label: "New password",
          },
        },
        [
          _c("p", { staticClass: "is-size-7 mb-3" }, [
            _vm._v(
              " Choose a password with eight characters or more. For a strong password, use a combination of lowercase and uppercase letters, numbers and special characters "
            ),
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.$v.password.$model,
                expression: "$v.password.$model",
                modifiers: { trim: true },
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.$v.password.$error },
            attrs: { type: "password" },
            domProps: { value: _vm.$v.password.$model },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.$v.password, "$model", $event.target.value.trim())
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          !_vm.$v.password.minLength
            ? _c("p", { staticClass: "help is-danger" }, [
                _vm._v(
                  " Password must have at least " +
                    _vm._s(_vm.$v.password.$params.minLength.min) +
                    " "
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "required-field",
        {
          attrs: {
            error: _vm.$v.repeatPassword.$error,
            required: _vm.$v.repeatPassword.required,
            label: "Confirm new password",
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.$v.repeatPassword.$model,
                expression: "$v.repeatPassword.$model",
                modifiers: { trim: true },
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.$v.repeatPassword.$error },
            attrs: { type: "password" },
            domProps: { value: _vm.$v.repeatPassword.$model },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.$v.repeatPassword,
                  "$model",
                  $event.target.value.trim()
                )
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          !_vm.$v.repeatPassword.sameAsPassword
            ? _c("p", { staticClass: "help is-danger" }, [
                _vm._v(" Passwords must be identical. "),
              ])
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "change-password-form__actions" }, [
        _c(
          "button",
          {
            staticClass: "button is-white gtm-cancel",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.cancel.apply(null, arguments)
              },
            },
          },
          [_vm._v(" Cancel ")]
        ),
        _c(
          "button",
          {
            staticClass: "button is-link is-outlined gtm-save",
            class: { "is-loading": _vm.fetching },
            on: { click: _vm.submit },
          },
          [_vm._v(" Update ")]
        ),
      ]),
      _vm.errorMessage
        ? _c("p", { staticClass: "help is-danger" }, [
            _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
          ])
        : _vm._e(),
      _c("span", { staticClass: "change-password-form__close" }, [
        _c(
          "button",
          {
            staticClass: "button is-white gtm-close",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.cancel.apply(null, arguments)
              },
            },
          },
          [_c("i", { staticClass: "far fa-times" })]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }